var map = {
	"./image/banner/ลูกค้าใหม่-05.png": "81f5",
	"./image/icons/6Rectangle.png": "6b81",
	"./image/icons/Asset 57.png": "fcde",
	"./image/icons/Asset 58.png": "213d",
	"./image/icons/Rectangle.png": "2237",
	"./image/icons/addImage.png": "4a54",
	"./image/icons/edit-pink.png": "2d1e",
	"./image/icons/edit.png": "2f6d",
	"./image/icons/editTemplate.png": "adda",
	"./image/icons/eng.png": "0d40",
	"./image/icons/image.png": "1f68",
	"./image/icons/link.png": "857d",
	"./image/icons/template.png": "64e2",
	"./image/icons/th.png": "304f",
	"./image/logo/Facebook_logo.png": "cef6",
	"./image/logo/LINE_logo.png": "4ac5",
	"./image/logo/Logo_black.png": "4758",
	"./image/logo/logo-main-menu.png": "a510",
	"./image/package/richmenu13.png": "2930",
	"./image/product/Asset 1.png": "3dac",
	"./image/product/Asset 2.png": "03c3",
	"./image/templat-logo.png": "81c7",
	"./logo.png": "cf05",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";